const documenttype = {
	name: 'Dokumentenart | Dokumentenarten',
	icon: 'fa-fw fas fa-file',
	fields: {
		acronym: 'Abkürzung',
		name: 'Bezeichnung',
		documents_count: 'Anzahl',
		ordering: 'Rheinfolge',
		notify: 'Benachrichtigungen',
		notify_of_weeks: 'Dokumente nicht älter als n Wochen',
		documents_size: 'Speicherplatz',
		proposed_for_export: 'Für Export vorgeschlagen',
		max_age_years: 'Max. Alter (Jahre)',
		document_cutoff_date: 'Stichtag',
		display_name: 'Anzeigename',
		display_label: 'Bezeichnung',
	},
	hideColumns: {
		acronym: '@:entity.documenttype.fields.acronym',
		documents_size: '@:entity.documenttype.fields.documents_size',
	},
}

export default documenttype
